<template>
  <div>
    <payin-form
      :is-active.sync="isEditing"
      method="put"
      :fee="editingOffer"
      @changed="offerUpdated"
    />
    <payin-form :is-active.sync="isAdding" @changed="offerAdded" />
    <data-table
      title="Withdraw Payout methods"
      ref="table"
      :url="url"
      :headers="headers"
      :archive="false"
      item-key="id"
      searchable
      @click:row="showPayoutMethodDetails"
    >
      <v-btn slot="action.icons" color="primary" @click="isAdding = true">
        Add a payout method fee configuration
        <v-icon class="ml-2" color="light-blue lighten-4"> mdi-account-money</v-icon>
      </v-btn>
    </data-table>
  </div>
</template>
<script>
import PayinForm from "./form.vue";
export default {
  components: {
    PayinForm,
  },
  data() {
    return {
      isAdding: false,
      isEditing: false,
      offer: {},
      editingOffer: null,
      url: `api/v1/transactions/feeConfigurations/${this.$route.params.id}/payoutMethod`,
      headers: this.pairTableLabelWithValue({
        PayInMethod: "cash_out_method.name",
        Country: "country.name",
        FeeType: "fee_type.name",
        Min: "cash_out_method.min_amount",
        Max: "cash_out_method.max_amount",
      }),
    };
  },
  watch: {
    url() {
      this.$nextTick(() => {
        this.$refs.table.fetchData();
      });
    },
  },
  computed: {
    feeConfigurationId() {
      return this.$route.params.id;
    },
  },
  created() {},
  methods: {
    showPayoutMethodDetails({ id }) {
      return this.$router.push({
        name: "withdraws.payoutmethods.show",
        params: { id, feeConfigurationId: this.feeConfigurationId },
      });
    },
    offerAdded({ message }) {
      this.isAdding = false;
      Notify.success(message);
      // refresh the table data
      this.$refs.table.fetchData();
    },
    offerUpdated({ message }) {
      this.editingOffer = null;
      this.isUpdating = false;
      Notify.success(message);
      // refresh the table data
      this.$refs.table.fetchData();
    },
    updateOffer(offer) {
      this.editingOffer = Object.assign({}, offer);
      this.isEditing = true;
    },
  },
};
</script>
